import { Radio } from "antd"
import FormStore from "../../Configs/Store/forms"

const SwitchBox = ({ onSwitchBoxToggle, type, defaultValue, value }) => {
  return (
    <Radio.Group defaultValue={defaultValue} value={value} buttonStyle="solid" style={styles[type].radioStyle} onChange={onSwitchBoxToggle}>
      <Radio.Button value={8}>@8%</Radio.Button>
      <Radio.Button value={4}>@4%</Radio.Button>
    </Radio.Group>
  )
}

const styles = {
  1: {
    radioStyle: {
      marginBottom: 29,
      marginTop: 5,
    },
  },
  0: {
    radioStyle: {
      marginBottom: 0,
      marginTop: 0,
      display: "flex",
    },
  },
}

export default SwitchBox
